import {
  CandidaciesSortKeyAndOrder,
  CandidacyStatus,
  CompensationType,
  EmploymentType,
  JobsSortKeyAndOrder,
  JobStatus,
  ShiftType,
} from "@/types";

// * IMPORTANT: This should be kept in sync with the roles on the talent side here:
// * https://github.com/Laborup/laborup-app/blob/master/web/src/lib/constants.ts#L18
export const roles = [
  "Machinist",
  "CNC operator",
  "CNC machinist",
  "CNC programmer",
  "Welder",
  "Fabricator",
  "MIG welder",
  "TIG welder",
  "Stick welder",
  "Flux-cored arc welder",
  "Underwater welder",
  "Pipeline welder",
  "Fabrication welder",
  "Structural steel welder",
  "Machine operator",
  "Line operator",
  "Production supervisor",
  "Assembly technician",
  "Quality control inspector",
  "Quality technician",
  "Maintenance technician",
  "Production technician",
  "Process engineer",
  "Manufacturing engineer",
  "Industrial engineer",
  "Mechanical engineer",
  "Electrical engineer",
  "Design engineer",
  "Welding engineer",
  "Structural engineer",
  "Automation engineer",
  "Robotics engineer",
  "Quality engineer",
  "Materials engineer",
  "Product engineer",
  "Aerospace engineer",
  "Aircraft technician",
  "Avionics technician",
  "Aerospace systems engineer",
  "Flight test engineer",
  "Satellite engineer",
  "Propulsion engineer",
  "Aerospace quality inspector",
  "Automotive engineer",
  "Automotive technician",
  "Automotive designer",
  "Vehicle systems engineer",
  "Powertrain engineer",
  "Chassis engineer",
  "Automotive quality inspector",
  "Biomedical engineer",
  "Environmental engineer",
  "Chemical engineer",
  "Metallurgical engineer",
  "Systems engineer",
  "Electrical systems engineer",
  "Mechanical systems engineer",
  "Tool and die maker",
  "Production planner",
  "Materials manager",
  "Logistics coordinator",
  "Supply chain analyst",
  "Robotics technician",
  "Paint technician",
  "Fabrication specialist",
  "Plant manager",
  "Safety coordinator",
  "Assembler",
  "Forklift operator",
  "Press operator",
  "Paint sprayer",
  "Quality inspector",
  "Metal fabricator",
  "Foundry worker",
  "Stamping operator",
  "Molding technician",
  "Body shop worker",
  "Die caster",
  "Rigging technician",
  "Sheet metal worker",
  "Pipefitter",
  "Lathe operator",
  "Grinding operator",
  "Extrusion operator",
  "Welding technician",
  "Electrical assembler",
  "Maintenance mechanic",
  "Tool grinder",
  "Heat treat operator",
  "Inventory clerk",
  "Shipping and receiving clerk",
  "Packaging worker",
  "Scaffold builder",
  "Utility worker",
  "Production assembler",
  "Test technician",
  "Overhaul mechanic",
  "Composite technician",
  "Parts inspector",
  "Finishing worker",
  "Drill press operator",
  "Setup technician",
  "Solderer",
  "Millwright",
  "Plating operator",
  "Turning operator",
  "EDM operator",
  "Precision grinder",
  "Milling machine operator",
  "Bore mill operator",
  "Swiss-style lathe operator",
  "Tool room attendant",
  "Jig bore operator",
  "Gear machinist",
  "CNC lathe machinist",
  "Multi-axis machinist",
  "Waterjet operator",
  "Laser machining operator",
  "Robot cell operator",
  "Quality assurance coordinator",
  "Industrial painter",
  "Safety inspector",
  "Metallurgical technician",
  "CAD technician",
  "CAM programmer",
  "Fixture builder",
  "Material handler",
  "Process control technician",
  "Production coordinator",
  "Control system technician",
  "Fabric cutter",
  "Seamstress/tailor",
  "Pneumatic systems technician",
  "Hydraulic systems technician",
  "Prototype builder",
  "Quality systems engineer",
  "Lean manufacturing engineer",
  "Production control analyst",
  "Inventory control specialist",
  "Supply chain planner",
  "Logistics analyst",
  "Material planner",
  "Distribution coordinator",
  "Fleet manager",
  "Maintenance planner",
  "Reliability engineer",
  "Operations manager",
  "Project manager",
  "Quality manager",
  "R&D engineer",
  "Systems analyst",
  "Network engineer",
];

export const defaultSearchCandidateDistanceOption = {
  label: "within 40 miles",
  value: "40",
};
export const searchCandidateDistanceOptions = [
  { label: "within 10 miles", value: "10" },
  { label: "within 20 miles", value: "20" },
  { label: "within 30 miles", value: "30" },
  defaultSearchCandidateDistanceOption,
  { label: "within 50 miles", value: "50" },
  { label: "more than 50 miles", value: "200" },
];

// TODO: This is a temporary solution. We will eventually fetch using the places API.
export const searchLocationOptions = [
  { label: "Knoxville, TN", value: "Knoxville, TN" },
  { label: "Maryville, TN", value: "Maryville, TN" },
  { label: "Oak Ridge, TN", value: "Oak Ridge, TN" },
  { label: "Sevierville, TN", value: "Sevierville, TN" },
  { label: "Powell, TN", value: "Powell, TN" },
  { label: "Clinton, TN", value: "Clinton, TN" },
  { label: "Morristown, TN", value: "Morristown, TN" },
  { label: "Vonore, TN", value: "Vonore, TN" },
  { label: "Loudon, TN", value: "Loudon, TN" },
  { label: "Lenoir City, TN", value: "Lenoir City, TN" },
  { label: "Alcoa, TN", value: "Alcoa, TN" },
  { label: "Jefferson City, TN", value: "Jefferson City, TN" },
  { label: "Athens, TN", value: "Athens, TN" },
  { label: "Niota, TN", value: "Niota, TN" },
  { label: "Madisonville, TN", value: "Madisonville, TN" },
];

export const defaultSearchYearsOfExperienceOption = {
  label: "Any job experience",
  value: "0",
};
export const searchYearsOfExperienceOptions = [
  defaultSearchYearsOfExperienceOption,
  { label: "1+ years", value: "1" },
  { label: "2+ years", value: "2" },
  { label: "3+ years", value: "3" },
  { label: "5+ years", value: "5" },
  { label: "10+ years", value: "10" },
];

export const stateOptions = [
  { value: "AL", label: "AL" },
  { value: "AK", label: "AK" },
  { value: "AZ", label: "AZ" },
  { value: "AR", label: "AR" },
  { value: "CA", label: "CA" },
  { value: "CO", label: "CO" },
  { value: "CT", label: "CT" },
  { value: "DE", label: "DE" },
  { value: "FL", label: "FL" },
  { value: "GA", label: "GA" },
  { value: "HI", label: "HI" },
  { value: "ID", label: "ID" },
  { value: "IL", label: "IL" },
  { value: "IN", label: "IN" },
  { value: "IA", label: "IA" },
  { value: "KS", label: "KS" },
  { value: "KY", label: "KY" },
  { value: "LA", label: "LA" },
  { value: "ME", label: "ME" },
  { value: "MD", label: "MD" },
  { value: "MA", label: "MA" },
  { value: "MI", label: "MI" },
  { value: "MN", label: "MN" },
  { value: "MS", label: "MS" },
  { value: "MO", label: "MO" },
  { value: "MT", label: "MT" },
  { value: "NE", label: "NE" },
  { value: "NV", label: "NV" },
  { value: "NH", label: "NH" },
  { value: "NJ", label: "NJ" },
  { value: "NM", label: "NM" },
  { value: "NY", label: "NY" },
  { value: "NC", label: "NC" },
  { value: "ND", label: "ND" },
  { value: "OH", label: "OH" },
  { value: "OK", label: "OK" },
  { value: "OR", label: "OR" },
  { value: "PA", label: "PA" },
  { value: "RI", label: "RI" },
  { value: "SC", label: "SC" },
  { value: "SD", label: "SD" },
  { value: "TN", label: "TN" },
  { value: "TX", label: "TX" },
  { value: "UT", label: "UT" },
  { value: "VT", label: "VT" },
  { value: "VA", label: "VA" },
  { value: "WA", label: "WA" },
  { value: "WV", label: "WV" },
  { value: "WI", label: "WI" },
  { value: "WY", label: "WY" },
];

export const candidacyScoreToLabel: Record<number, string> = {
  1: "Not suitable",
  2: "Reserve candidate",
  3: "Decent fit",
  4: "Strong match",
  5: "Ideal profile",
};
export const candidacyScoreOptions = Object.entries(candidacyScoreToLabel).map(
  (entry) => ({
    label: entry[1],
    value: entry[0],
  }),
);

export const candidacyStatusToBackgroundColor: Record<CandidacyStatus, string> =
  {
    [CandidacyStatus.MATCHED]: "bg-yellow-600",
    [CandidacyStatus.INTERVIEW]: "bg-purple-600",
    [CandidacyStatus.OFFER]: "bg-green-600",
    [CandidacyStatus.REJECTED]: "bg-red-600",
  };
export const candidacyStatusToLabel: Record<CandidacyStatus, string> = {
  [CandidacyStatus.MATCHED]: "Matched",
  [CandidacyStatus.INTERVIEW]: "Interview",
  [CandidacyStatus.OFFER]: "Offer",
  [CandidacyStatus.REJECTED]: "Rejected",
};
export const candidacyStatusToRank: Record<CandidacyStatus, number> = {
  [CandidacyStatus.MATCHED]: 3,
  [CandidacyStatus.INTERVIEW]: 4,
  [CandidacyStatus.OFFER]: 5,
  [CandidacyStatus.REJECTED]: 6,
};
export const candidacyStatusOptions = Object.entries(
  candidacyStatusToLabel,
).map((entry) => ({
  label: entry[1],
  value: entry[0] as CandidacyStatus,
}));
export const candidacyStatusOptionsExRejected = candidacyStatusOptions.filter(
  (option) => option.value !== CandidacyStatus.REJECTED,
);

const compensationTypeToLabel: Record<CompensationType, string> = {
  [CompensationType.HOURLY]: "Hourly",
  [CompensationType.YEARLY]: "Yearly",
};
export const compensationTypeOptions = Object.entries(
  compensationTypeToLabel,
).map((entry) => ({
  label: entry[1],
  value: entry[0] as CompensationType,
}));

export const employmentTypeToLabel: Record<EmploymentType, string> = {
  [EmploymentType.CONTRACT]: "Contract",
  [EmploymentType.FULLTIME]: "Full-time",
  [EmploymentType.PARTTIME]: "Part-time",
};
export const employmentTypeOptions = Object.entries(employmentTypeToLabel).map(
  (entry) => ({
    label: entry[1],
    value: entry[0] as EmploymentType,
  }),
);

export const jobStatusToBackgroundColor: Record<JobStatus, string> = {
  [JobStatus.ACTIVE]: "bg-green-600",
  [JobStatus.REVIEW]: "bg-yellow-500",
  [JobStatus.DRAFT]: "bg-slate-400",
  [JobStatus.CLOSED]: "bg-red-600",
};
// * IMPORTANT: Important to keep these in the following order.
export const jobStatusToLabel: Record<JobStatus, string> = {
  [JobStatus.ACTIVE]: "Active",
  [JobStatus.REVIEW]: "In Review",
  [JobStatus.DRAFT]: "Draft",
  [JobStatus.CLOSED]: "Closed",
};
export const jobStatusOptions = Object.entries(jobStatusToLabel).map(
  (entry) => ({
    label: entry[1],
    value: entry[0] as JobStatus,
  }),
);
export const jobStatusOptionsForCreate = jobStatusOptions.filter(
  (option) =>
    option.value !== JobStatus.CLOSED && option.value !== JobStatus.ACTIVE,
);
export const jobStatusOptionsForNonActiveUpdate = jobStatusOptions.filter(
  (option) => option.value !== JobStatus.ACTIVE,
);

const shiftTypeToLabel: Record<ShiftType, string> = {
  [ShiftType.FIRSTSHIFT]: "First shift",
  [ShiftType.SECONDSHIFT]: "Second shift",
  [ShiftType.THIRDSHIFT]: "Third shift",
  [ShiftType.WEEKEND]: "Weekend",
};
export const shiftTypeOptions = Object.entries(shiftTypeToLabel).map(
  (entry) => ({
    label: entry[1],
    value: entry[0] as ShiftType,
  }),
);

export const defaultJobsSortKeyAndOrder = JobsSortKeyAndOrder.CreatedAtDesc;

export const defaultCandidaciesSortKeyAndOrder =
  CandidaciesSortKeyAndOrder.TimeInStageAsc;
